<template>
    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <!--  新增按钮      -->
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="addDish">新增菜品</el-button>
            <!-- 搜索区域-->
            <div style="margin-right: 20px">
                <span class="titlew">菜品类型</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        @change="cpchange"
                        v-model="cpTypedata.id"
                        filterable>
                    <el-option
                            v-for="item in cpTypedata"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <!-- 搜索框 -->
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="searchData"
                        clearable>
                </el-input>
                <!-- 搜索按钮 -->
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            </div>

        </div>
        <!--  表格  -->
        <el-table
                id="eltable"
                ref="ftable"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                style="width: 100%"
                stripe
                border
                :header-cell-style="{background:'#eef1f6',color:'black',}"
                :header-row-style="{height:'50px'}"
                :highlight-current-row="true"
        >
            <el-table-column type="index" :index="hIndex" label="序号" width="60"/>
            <el-table-column
                    prop="name"
                    label="菜品名称"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="foodType"
                    label="菜品类型"
                    width="250px"
                    show-overflow-tooltip
            >
<!--                <template slot-scope="scope" >-->
<!--                    <div >-->
<!--                        <span v-if="scope.row.foodType==1">小碗菜</span>-->
<!--                        <span v-if="scope.row.foodType==2">熟食</span>-->
<!--                    </div>-->

<!--                </template>-->
            </el-table-column>
            <el-table-column
                    prop="price"
                    width="200px"
                    label="价格(元)"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="filePath"
                    width="150px"
                    label="图片"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-image style="width: 60px; height: 60px;margin-left: 30px;margin-bottom: -10px" :src="scope.row.filePath"
                              :preview-src-list="[scope.row.filePath]" :key="scope.row.id"
                                slot="reference" :alt="scope.row.filePath"
                    >
                        <div slot="error" class="image-slot" style="text-align: center;line-height: 60px">
                            <!--                            <i class="el-icon-picture-outline"></i>-->
                            <div>无</div>
                        </div>
                    </el-image>

                </template>
<!--                <img :src="filePath">-->
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    width="260px"
                    label="发布时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    width="200px"
                    label="录入人名字"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="state"
                    label="状态"
                    width="100"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.state==1">启用</span>
                    <span v-if="scope.row.state==0">未启用</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="170"
                    label="操作">
                <template slot-scope="scope" >
                    <div>
                        <el-button  type="text" size="mini" @click="editDish(scope.row)">编辑</el-button>
                        <el-button  style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!-- 父表格 -->

        <!-- 分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <!--
                    small：是否使用小型分页样式
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：总条目数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔
                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10,20,30,40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <!--
                    small：是否使用小型分页器
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：条目总数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔
                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->

                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 分页器-->
        <!--  新增菜品弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold;margin-top: -350px"
                top="350px"
                width="31.429rem"
                height="300"
                :title="title"
                :visible.sync="addDialog"
                v-if="addDialog"
        >
            <addDish  @close="close" :editData1 = "editData" :title="title" @getList="getList"></addDish>
        </el-dialog>

        <!--  弹窗  -->
        <!--  删除产线弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialog"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialog"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialog = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>

    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import addDish from "./component/AddDish";


    export default{
        name: "dishInformation",
        components:{
            addDish
        },

        data(){
            return{
                sonIndex:"",
                delDialog:false,
                flowPath:false,
                childrenlist:[],
                // typeList:[{
                //     id:1,
                //     v:'小碗菜'
                // },{
                //     id:2,
                //     v:'熟食'
                // }],
                editData:{},
                addDialog:false,//编辑弹窗
                currentPage:1,
                pageSize:10,
                deldetail:'',
                total:0,
                baseerp:'',
                searchData:'',
                foodType:'',
                cpTypedata:{},
                // tableData: [
                //     {name:"包子",foodType:0,price:2,pic:""},
                //     {name:"鱼香肉丝",foodType:1,price:17,pic:""}
                // ],
                tableData:[],
                tableHeight:0,//列表高度
                title:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.getDataDict()

            this.$nextTick(()=>{
                this.onResize();

            })
            // this.$refs.deliverlight.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp


        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            hIndex(index) {
                // 当前页数 - 1 * 每页数据条数 + index + 1 （ index 是索引值，从0开始）
                return (this.currentPage - 1) * this.pageSize + index + 1
            },
             cpchange(val){
                // console.log(val)

                // await  this.getDataDict()
                //  setTimeout(() => {
                    this.cpTypedata.id=val
                // }, 1)

            },

            clist(){
                this.tableData.forEach(item=>{
                    this.$refs.ftable.toggleRowExpansion(item,false)

                })
                // this.$refs.deliverlight.toggleRowExpansion(item,false)

            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){

                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36;

            },

            //关闭弹框
            close(){
                this.flowPath=false
                this.addDialog=false
            },
            //页面搜索
            Search(){
                this.foodType=this.cpTypedata.id
                this.getList()
                //this.dcslist()
                //console.log(this.tableData)
                this.currentPage=1
            },
            //分页
            //监听pagesize改变的事件
            handleSizeChange(newsize) {
                //console.log(`每页 ${newsize} 条`);
                //最新的条数（newsize）赋值给 动态的 pageSize
                this.pageSize = newsize;    //动态改变
                this.getList()
                //获取到最新一页显示的数据  重新发送请求
                //this.clist()
                //this.dcslist()
            },
            // 监听 页码值 改变的数据
            //监听页码值改变的数据
            handleCurrentChange(newPage) {
                // console.log(`当前页: ${newPage}`);
                //把最新的页码（newPage）赋值给 动态的 currentPage
                this.currentPage = newPage;    //动态改变
                this.getList()
                //获取到最新页码值  重新发送请求
                //this.clist()
                //this.dcslist()
            },
            //新增菜品
            addDish(){
                this.title='新增菜品'
                this.editData={
                    name:'',
                    price:0,
                    createTime:'',
                    // vc_lruname:sessionStorage.getItem('lruname'),
                    state:1
                }
                this.addDialog=true


            },
            //编辑菜品
            editDish(val){
                // console.log(val)
                this.title='编辑菜品'
                // console.log(val)
                this.editData.id = val.id
                //this.editData.id=val.id
                //this.editData=Object.assign({},val);
                this.addDialog=true
                // this.getServiceConfigDetail()
                // console.log(this.editData)
            },


            //删除产线(父)
            del(val){
                this.title='删除'
                this.editData=val

                // this.templateUsed()
                this.deldetail='是否要删除'
                this.delDialog=true

            },
            //产线确认作废(父)
            submitdel(){
                this.remove()
                // console.log(this.editData)
                this.delDialog=false
            },
            //菜品类型下拉
            async getDataDict(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    type: 1,
                }
                let res = await API.getDataDict(params);
                if (res.code == 1) {

                    this.cpTypedata = res.data
                    // this.foodType=res.data.id
                    // console.log(this.cpTypedata)
                    // let arr=[]
                    this.getList()
                    // this.kqdata.map(item=>{
                    //     arr.push(item.storekqId)
                    // })
                    // arr.map((value,i)=>{
                    // for (var i = 0; i < arr.length; i++) {
                    //     if(arr[i]==this.pid){
                    //         return
                    //     }else {
                    //         this.pid=''
                    //     }
                    // }
                    // let arr =  res.data;
                    // this.pid=arr[1].storepid
                    // this.getList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //菜品列表
            async getList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    search:this.searchData,
                    foodType:this.foodType
                }
                let res = await API.getList(params);
                if (res.code == 1) {
                    this.tableData=res.data
                    // console.log(res.data)
                    this.total=res.total
                    // this.tableData.forEach(item=>{
                    //     item.createTime=item.createTime.substring(0,19)
                    // })
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            // 业务配置作废
            async remove() {
                // await this.getDetails()
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id
                }
                let res = await API.remove(params);
                if (res.code == 1) {
                    this.getList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.$message.error(res.message);
                }
            },


        },

    }
</script>

<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }
    .titlew{
         padding: 0 10px;
         font-size: 14px;
     }
    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
    .left{
        width: 17.857rem;
    }
</style>